<template>
    <div>
        <buttonlist
                ref="SetBtn" @help="help"
        ></buttonlist>
        <div style="width:100%">
            <div  style="display: flex">
                <el-button type="success" size="mini" @click="getModel">{{$t('getapi[7420]')}}<i class="el-icon-download el-icon--right"></i></el-button>
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadurl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        :limit="1"
                        style="margin-left: 8px;width:150px"
                >
                    <el-button type="primary" plain size="mini">{{$t('getapi[7421]')}}<i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                </el-upload>
                <el-button type="primary" size="mini" @click="getDataFromCards">{{$t('getapi[7422]')}}</el-button>
                <el-button type="primary" size="mini" @click="removeT" :disabled="!datajson.list.length>0">{{$t('getapi[7423]')}}</el-button>
                <el-button type="primary" size="mini" @click="clearT" :disabled="!datajson.list.length>0">{{$t('getapi[7424]')}}</el-button>
                <el-button type="primary" size="mini" @click="doVerify" :disabled="!datajson.list.length>0">{{$t('getapi[439]')}}</el-button>
                <el-button type="primary" size="mini" @click="doCount(0)" :disabled="!btn.cancount">{{$t('getapi[2530]')}}</el-button>
                <el-button type="primary" size="mini" @click="exps" :disabled="!btn.export">{{$t('getapi[7425]')}}</el-button>
            </div>
            <div style="display: flex;margin-top: 5px;margin-bottom: 5px">
                <tr>
                    <td>{{ $t('getapi[1974]') }}</td>
                    <td>
                        <el-select filterable v-model="cboyear"  size="mini" style="margin-right:20px">
                            <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                    <td>{{ $t('getapi[1975]') }}</td>
                    <td>
                        <el-select filterable v-model="cbomonth"  size="mini" style="margin-right:20px">
                            <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="refresh" style="margin-right:20px" :disabled="!datajson.list.length>0">{{$t('getapi[7426]')}}</el-button>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="removeCheckFailed" style="margin-right:20px" :disabled="!btn.afterverify">{{$t('getapi[7427]')}}</el-button>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="expCheckFailed" :disabled="!btn.afterverify">{{$t('getapi[7428]')}}</el-button>
                    </td>
                </tr>
            </div>
            <div id="xpane-0">
                <vxe-table :data="datajson.list" size="mini" :loading="loading" header-cell-class-name="headerclass" ref='VXTable'
                       :height="tableHeight"
                       @row-click="selectrow"
                       :highlight-current-row="true"
                       v-loading="loading"
                       stripe
                       border
                       show-overflow="tooltip"
                       resizable>
                <vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="verify_desc" :title="$t('getapi[7429]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_card_issue_no" :title="$t('getapi[7430]')" width="140"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_card_no" :title="$t('getapi[7431]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="count_area" :title="$t('getapi[7432]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="so_code" :title="$t('getapi[7433]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="routing_no" :title="$t('getapi[573]')" width="100"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="sys_measure" :title="$t('getapi[7434]')" width="100"></vxe-table-column>
                <vxe-table-column field="count_qty" :title="$t('getapi[1628]')" align="right" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.count_qty | thousandth}}
                    </template>
                </vxe-table-column>
                <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[3437]')" width="100"></vxe-table-column>
            </vxe-table>
            </div>
        </div>

        <el-dialog v-dialogDrag :visible.sync="isShowSelectSheet" width="25%" :close-on-click-modal="false">
            <el-table
                    :data="dataSelectSheet"
                    ref="sheetTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    @row-click="changeItem_code"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[6388]')"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowSelectSheet = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="getNoBalanceData" :disabled="selectNameData.length != 1">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[7435]')" :visible.sync="showCard" width="25%" :close-on-click-modal="false" >
            <tr>
                <td>{{$t('getapi[7436]')}}</td>
                <td>
                    <el-select filterable v-model="selcountplan" size="mini">
                        <el-option v-for="item in arrcountplan" :key="item.Code" :label="item.Code" :value="item.Code"></el-option>
                    </el-select>
                </td>
            </tr>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showCard = false">{{$t('getapi[1717]')}}</el-button>
				<el-button type="primary" size="mini" @click="confirmGetDataFromCard()">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_costcalc',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                datajson: {
                    URL: '',
                    list: []
                },
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                isShowSelectSheet: false, // 是否显示选择sheet弹窗
                dataSelectSheet: [], //
                selectNameData: [], // 选择的sheet
                selectIndex: '', //选中行下标
                showCard: false,
                arrcountplan: [],
                selcountplan: '', //选择的盘点计划
                cboyear: '',
                cbomonth: '',
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                btn: {
                    afterverify: false,
                    cancount: false,
                    export: false
                },
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Fin/StdWIPCostCalc/WIPCostCalcUpFile?token=' + token;
        },
        watch: {
            'datajson.list': function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function() {
            let that = this;
            let thisyear = new Date().getFullYear();
            for(let i=0;i<5;i++){
                let obj = {
                    value: thisyear-i,
                    label:thisyear-i
                };
                that.yearList.push(obj);
            }
            that.cboyear = thisyear;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.VXTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.VXTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6691]"),this.$t("getapi[979]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    that.returnURL = res.DataContent.URL;
                    let arr = res.DataContent.SheetList
                    if(arr.length > 0){
                        that.dataSelectSheet = []
                        for(let i=0;i<arr.length;i++){
                            that.dataSelectSheet = [...that.dataSelectSheet,{
                                name: arr[i]
                            }]
                        }
                        that.isShowSelectSheet = true
                    }
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            // 获得在制数据导入模板
            getModel(){
                let that = this
                that.$http.urlpost('/Fin/StdWIPCostCalc/WIPCostCalcExportTemplate', '', function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            changeItem_code(row) {
                let that = this
                that.$refs.sheetTable.toggleRowSelection(row);
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this
                console.log(val)
                that.selectNameData = []
                for(let i = 0;i<val.length;i++){
                    that.selectNameData.push(val[i].name)
                }
            },
            getNoBalanceData(){
                let that = this
                let parm = {
                    filepath: that.returnURL,
                    sheetname: that.selectNameData[0]
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/GetNoBalanceLockData', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent
                        that.btn.afterverify = false
                        that.btn.cancount = false
                        that.btn.export = false
                        that.isShowSelectSheet = false
                    }
                    that.authority();
                });
            },
            removeT(){
                let that = this;
                let selectRecords = this.$refs.VXTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.VXTable.getRowIndex(selectRecords[i]);
                    that.datajson.list.splice(line, 1);
                }
                that.btn.cancount = that.datajson.list.every(val => {
                    return val.verify_desc == '校验通过'
                })
            },
            clearT(){
                let that = this
                that.datajson.list = []
            },
            // 从盘点卡加载数据
            getDataFromCards(){
                let that = this
                that.showCard = true
                that.getSelectData()
            },
            getSelectData(){
                let that = this
                that.$http.urlpost('/Fin/StdWIPCostCalc/GetCountPlanSignList', '', function (res) {
                    if (res.Success == 1) {
                        that.arrcountplan = res.DataContent
                    }
                });
            },
            confirmGetDataFromCard(val){
                let that = this
                let parm = {
                    costyear: that.cboyear,
                    cbomonth: that.cbomonth,
                    selcountplan: that.selcountplan,
                    iscontinue: val
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/GetLoadCountCardsDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent
                        that.btn.afterverify = false
                        that.btn.cancount = false
                        that.btn.export = false
                        that.showCard = false
                    } else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmGetDataFromCard(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 校验
            doVerify(){
                let that = this
                that.loading = true
                let parm = {
                    costyear: that.cboyear,
                    cbomonth: that.cbomonth,
                    list: that.datajson.list
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/VerifyCountCardsData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.datajson = res.DataContent
                        that.btn.cancount = true
                    }
                     else if (res.Success == 2) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.datajson = res.DataContent
                        that.btn.cancount = false
                    }
                    that.btn.afterverify = true
                    that.loading = false
                });
            },
            // 计算
            doCount(val) {
                let that = this
                that.loading = true
                let parm = {
                    costyear: that.cboyear,
                    cbomonth: that.cbomonth,
                    iscontinue: val,
                    list: that.datajson.list
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/CalcCountCardsData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.btn.export = true
                    }  else if (res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.doCount(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    that.loading = false
                });
            },
            // 导出结果
            exps(){
                let that = this
                let parm = {
                    costyear: that.cboyear,
                    cbomonth: that.cbomonth,
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/CalcCountCardsDataToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            refresh(){
                let that = this
                let parm = {
                    list: that.datajson.list
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/RefreshPartVersion', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent
                    }
                });
            },
            removeCheckFailed(){
                let that = this
                for (let i = that.datajson.list.length - 1; i >= 0; i--) {
                    if(that.datajson.list[i].verify_desc != '校验通过'){
                        that.datajson.list.splice(i, 1);
                    }
                }
                that.btn.cancount = true
            },
            expCheckFailed(){
                let that = this
                let parm = {
                    list: that.datajson.list
                }
                that.$http.urlpost('/Fin/StdWIPCostCalc/NoVerifyDataToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
